import React from 'react';
import ListingPage from './ListingPage';
import AdminPinGate from './AdminPinGate';

/** Same wizard as /listing. Staff PIN once, then create the host without email OTP. */
const ListingByAdminPage = () => (
  <AdminPinGate>
    <ListingPage mode="signup" skipOtp />
  </AdminPinGate>
);

export default ListingByAdminPage;
